import { configureStore } from "@reduxjs/toolkit";
import searchBoxReducer from "./search";

const store = configureStore({
  reducer: {
    search: searchBoxReducer,
  },
});

export default store;
